import { useEffect, useState, useCallback } from "react";
import * as Sentry from "@sentry/react";
import apiPaths from "../api/endpoints";
import apiClientTwo from "../api/apiClient2";
import { PROFILE_TYPE } from "../utils/constants";
import config from "../config/environment";

export function useCurrentUser() {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCurrentUser = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const res = await apiClientTwo.get(apiPaths.GET_USER);

      setData(res.data);

      const knownRoles = Object.values(PROFILE_TYPE);
      if (res.data?.userName) {
        if (knownRoles.includes(res.data.profileType)) {
          try {
            Sentry.setUser({
              id: res.data.userName,
              role: res.data.profileType,
              schoolHash: res.data.schoolHash,
            });
          } catch (err) {
            console.error("Sentry.setUser failed", err);
          }
        } else if (config.env === "development") {
          // Backend added a role the dashboard doesn't recognize. Log in dev only;
          // do NOT include the role value in production — it may identify a student.
          console.warn("[sentry] Unknown profileType; skipping Sentry.setUser to preserve privacy posture.");
        }
      }
    } catch (err: any) {
      console.error("Get User API error:", err);
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCurrentUser();
  }, [fetchCurrentUser]);

  return {
    data,
    loading,
    error,
    refetch: fetchCurrentUser,
  };
}
